import { z } from 'zod'

export const profileGenderSchema = z.enum(['Laki-laki', 'Perempuan'])

export const profileOccupationOptions = [
  'Karyawan Swasta',
  'Ibu Rumah Tangga',
  'Pengusaha',
  'Pelajar',
  'Freelance',
] as const

function isHttpUrl(value: string) {
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

export const profileCompletionSchema = z.object({
  jastipName: z
    .string()
    .trim()
    .min(1, 'Nama Jastip wajib diisi.')
    .max(50, 'Nama Jastip maksimal 50 karakter.'),
  gender: z
    .union([profileGenderSchema, z.literal('')])
    .refine((value) => value !== '', 'Pilih jenis kelamin.'),
  occupation: z
    .string()
    .trim()
    .min(1, 'Pekerjaan wajib diisi.')
    .max(100, 'Pekerjaan maksimal 100 karakter.'),
  address: z
    .string()
    .trim()
    .min(1, 'Alamat lengkap wajib diisi.')
    .max(200, 'Alamat maksimal 200 karakter.'),
  additionalAddress: z.string().trim().max(100, 'Patokan maksimal 100 karakter.'),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  destination: z
    .object({
      route_id: z.number().int(),
      route: z.string(),
    })
    .nullable()
    .refine(
      (value) => value !== null && value.route_id > 0,
      'Pilih kecamatan dari hasil pencarian.',
    ),
  socialMediaLinks: z
    .array(
      z.object({
        url: z
          .string()
          .trim()
          .refine(
            (value) => new TextEncoder().encode(value).length <= 100,
            'Tautan maksimal 100 byte.',
          )
          .refine(
            (value) => !value || isHttpUrl(value),
            'Masukkan tautan valid yang diawali http:// atau https://.',
          ),
      }),
    )
    .refine(
      (links) => links.some(({ url }) => isHttpUrl(url)),
      'Tambahkan minimal satu tautan sosial media yang valid.',
    ),
})

export type ProfileFormValues = z.input<typeof profileCompletionSchema>
